import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { Input, Input3 } from "../../common/control/InputField";

export const AddBankForm = ({ formikRef, saveValues }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={{
        bankname: "",
        accountname: "",
        accountnum: "",
      }}
      innerRef={formikRef}
      enableReinitialize={true}
      onSubmit={(values, formikHelpers) => {
        let queryParams = {
          action: "addmasterbankaccount",
          bankname: values.bankname,
          accountname: values.accountname,
          accountnum: values.accountnum,
        };
        saveValues(queryParams);
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "bankName" })}
            </label>

            <Field
              name="bankname"
              component={Input3}
              placeholder={intl.formatMessage({ id: "bankName" })}
              autoComplete="off"
              type="text"
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "accountName" })}
            </label>

            <Field
              name="accountname"
              component={Input3}
              placeholder={intl.formatMessage({ id: "accountName" })}
              autoComplete="off"
              type="text"
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "accountNum" })}
            </label>

            <Field
              name="accountnum"
              component={Input}
              placeholder={intl.formatMessage({ id: "accountNum" })}
              autoComplete="off"
              type="number"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
